import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { type ModalProps } from './modal';
import { modalClasses } from './modal.classes';
import { useModalStyles } from './modal.styles';

import type { JSX } from 'react';

export const ModalLargeOrMediumViewport = ({
  isOpen,
  className,
  verticalPosition,
  styles,
  disableTransition = false,
  children,
  role,
  onClose,
  ...rest
}: ModalProps): JSX.Element => {
  const css = useModalStyles({ verticalPosition });

  const backdropSlotProps = {
    classes: { root: modalClasses.backdrop },
    style: styles?.backdrop,
    sx: css.backdrop,
    ...(disableTransition && {
      transitionDuration: { enter: 0, exit: 0 },
    }),
  };

  const containerStyle = disableTransition
    ? { ...styles?.container, animation: 'none' as const }
    : styles?.container;

  return (
    <Modal
      {...rest}
      onClose={onClose}
      role={role ?? 'dialog'}
      aria-modal='true'
      open={isOpen}
      className={className}
      slotProps={{
        root: { className: modalClasses.root },
        backdrop: backdropSlotProps,
        ...(disableTransition && {
          transition: { timeout: { enter: 0, exit: 0 } },
        }),
      }}
      style={styles?.root}
      css={css.root}
    >
      <Box className={modalClasses.container} style={containerStyle}>
        {children}
      </Box>
    </Modal>
  );
};
